import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["width", "title", "onOpenComplete", "onClose", "description", "card", "footer", "trackingProperties"];
import { useCallback } from 'react';
import { H2 } from 'foundations-components/transitional/components/H2';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { NextActionModalBody } from './modal/NextActionModalBody';
import { NextActionModalFooter } from './modal/NextActionModalFooter';
import { trackView, trackUserInteraction } from './utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const NextActionModal = _ref => {
  let {
      width = '720px',
      title,
      onOpenComplete,
      onClose,
      description,
      card,
      footer,
      trackingProperties = {}
    } = _ref,
    modalProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const handleOpenComplete = useCallback(() => {
    onOpenComplete === null || onOpenComplete === void 0 || onOpenComplete();
    trackView('next action modal', trackingProperties);
  }, [trackingProperties, onOpenComplete]);
  const handleClose = useCallback(() => {
    onClose();
    trackUserInteraction('next action modal', 'close modal', trackingProperties);
  }, [trackingProperties, onClose]);
  return /*#__PURE__*/_jsxs(Modal, Object.assign({}, modalProps, {
    onOpenComplete: handleOpenComplete,
    width: width,
    use: "success",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: handleClose
      }), /*#__PURE__*/_jsx(H2, {
        children: title
      })]
    }), /*#__PURE__*/_jsx(NextActionModalBody, {
      description: description,
      card: card,
      trackingProperties: trackingProperties
    }), /*#__PURE__*/_jsx(NextActionModalFooter, Object.assign({}, footer, {
      trackingProperties: trackingProperties
    }))]
  }));
};